/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_password_not_set = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No password set`)
};

const zh_hans1_settings_password_not_set = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未设置密码`)
};

const zh_hant1_settings_password_not_set = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未設定密碼`)
};

const fr_settings_password_not_set = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun mot de passe défini`)
};

const de_settings_password_not_set = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Passwort gesetzt`)
};

const ja_settings_password_not_set = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードが設定されていません`)
};

const ko_settings_password_not_set = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호가 설정되지 않음`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_password_not_set = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_password_not_set(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_password_not_set", locale)
	if (locale === "en") return en_settings_password_not_set(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_password_not_set(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_password_not_set(inputs)
	if (locale === "fr") return fr_settings_password_not_set(inputs)
	if (locale === "de") return de_settings_password_not_set(inputs)
	if (locale === "ja") return ja_settings_password_not_set(inputs)
	return ko_settings_password_not_set(inputs)
};